/**
 * One key per "Auftrag anlegen" form instance — protects against double-submit only.
 * Must not depend on installation, template, technician, or date (multiple orders per day are allowed).
 */
export function newMaintenanceWorkOrderCreateIdempotencyKey(): string {
  return crypto.randomUUID();
}
